/**
 * Used to mark this package's client in order to validate the right client is
 * provided.
 */
export const aiClientSymbol = Symbol.for("apollo.aiClient");
